// extracted by mini-css-extract-plugin
export var grid = "index-module--grid--_TzLl";
export var thin = "index-module--thin--3J4OG";
export var half = "index-module--half--2gY1G";
export var wide = "index-module--wide--174Uf";
export var full = "index-module--full--126YM";
export var wideNestedGrid = "index-module--wideNestedGrid--13Jxv";